import { LocationQuery } from 'vue-router';
import { cacheFirstConfig, http } from '../../helpers/http.helper';
import { ApiResource } from '../../models/api-resource.interface';
import { CommunicationPreferenceType } from './communication-preference-type.interface';

export class CommunicationPreferenceTypeService {
   async getCommunicationPreferenceTypes(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<CommunicationPreferenceType>>>(`/communication-preference-types`, {
         ...cacheFirstConfig,
         params: { ...query },
      });
      return response.data;
   }
}
